import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad } from '../components/';
import { Dictionary } from '../Dati';


interface IInputTestoProps extends Dati.IBaseProps {
    Etichetta: any;
    Valore: string;
    Righe?: number;
}

export class InputTesto extends BasePureComponent<IInputTestoProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string")){
            etichetta = <label>{Trad.Trad(this.props.Etichetta)}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }
        return <div style={{ minHeight: 88 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <textarea
                    className="form-control"
                    value={this.props.Valore}
                    name={this.props.Name}
                    id={this.props.Id}
                    onChange={this.props.OnChange}
                    rows={this.props.Righe != undefined ? this.props.Righe : 4}
                    required={this.props.Richiesto || false}
                    onBlur={this.props.OnBlur}
                    readOnly={this.props.Scrittura || false} />
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputTesto.tsx